if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.sidecart = document.querySelector("side-cart");
        this.termsCheckbox = this.querySelector("input#so-terms-checkbox");
        this.specialTermsCheckbox = this.querySelector(
          "input#special-order-terms-checkbox"
        );
        this.errors = [];
        this.customFields = null;
        this.lineProps = {};

        if (this.termsCheckbox || this.specialTermsCheckbox) {
          this.termsCheckbox?.addEventListener(
            "change",
            this.toggleATC.bind(this)
          );
          this.specialTermsCheckbox?.addEventListener(
            "change",
            this.toggleATC.bind(this)
          );
          this.toggleATC();
        }
      }

      getCustomFields() {
        this.customFields =
          this.customFields || this.querySelector("#customFields")?.textContent
            ? JSON.parse(this.querySelector("#customFields").textContent)
            : null;
        return JSON.parse(this.customFields);
      }

      validateCustomizationFields() {
        this.customFields = this.getCustomFields();

        if (
          !(
            this.customFields?.personalization_fields &&
            this.customFields?.personalization_fields?.split(",")?.length
          )
        ) {
          this.errors = [];
          return [];
        }

        const helpTexts = (
          this.customFields.personalization_help_text || ""
        ).split("|###|");
        const labels = (this.customFields.personalization_label || "").split(
          "|###|"
        );
        const maxLengths = (
          this.customFields.personalization_max_length || ""
        ).split("|###|");
        const options = (this.customFields.personalization_options || "").split(
          "|###|"
        );
        const placeholders = (
          this.customFields.personalization_placeholder || ""
        ).split("|###|");
        const requiredFlags = (
          this.customFields.personalization_required || ""
        ).split("|###|");
        const types = (this.customFields.personalization_type || "").split(
          "|###|"
        );

        for (let i = 0; i < labels.length; i++) {
          this.lineProps[`${labels[i]}`] = "";
        }

        const customizationFields = this.customFields.personalization_fields
          .split(",")
          .map((index) => ({
            helpText: helpTexts[index],
            label: labels[index],
            maxLength: maxLengths[index],
            options: options[index]
              ? options[index].split(",").map((opt) => {
                  return { label: opt, value: opt };
                })
              : [],
            placeholder: placeholders[index],
            required: requiredFlags[index],
            type: types[index],
          }));

        this.errors = [];
        if (customizationFields.length === 0) return true;
        for (let i = 0; i < customizationFields.length; i++) {
          this.querySelectorAll("[data-line-prop]")?.forEach((el) => {
            if (
              customizationFields[i].required === "1" &&
              (el?.value?.length === 0 || el?.selectedOptions?.length === 0)
            ) {
              this.errors.push(`${customizationFields[i].label} is required.`);
            }
          });
        }
      }
      toggleATC() {
        if (this.termsCheckbox.checked) {
          this.querySelector('[type="submit"]').removeAttribute("disabled");
        } else {
          this.querySelector('[type="submit"]').setAttribute(
            "disabled",
            "disabled"
          );
        }
      }

      async addGiftToCart() {
        fetch("/cart.js")
          .then((response) => {
            return response.json();
          })
          .then(async (data) => {
            let formData;
            let applicableGif = false;

            if (window.gift_by === "cart_amount") {
              if (data.total_price >= Number(window.gift_price * 100)) {
                applicableGif = true;
              }
            } else if (window.gift_by === "adding_product_with_tags") {
              const productTags = await Promise.all(
                data.items.map(async (el) => {
                  let productInfo = await fetch(`/products/${el.handle}.js`);
                  productInfo = await productInfo.json();
                  return productInfo.tags;
                })
              );
              const applicableTags = window.gift_tags.split(",");
              productTags.forEach((pt) => {
                if (applicableGif) return;
                applicableTags.forEach((at) => {
                  if (pt.includes(at)) {
                    applicableGif = true;
                    return;
                  }
                });
              });
            }

            if (!applicableGif) return;

            let isExist = false;

            data.items.forEach((value, index, array) => {
              if (value.id === +window.gift_variant_id) {
                isExist = true;
              }
            });

            if (isExist) {
              return;
            }

            formData = {
              items: [
                {
                  id: parseInt(window.gift_variant_id),
                  quantity: 1,
                },
              ],
              sections: this.sidecart
                ?.getSectionsToRender()
                .map((section) => section.id)
                .join(),
            };

            fetch(`${routes.cart_add_url}.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                this.sidecart?.renderContents(response);
                return response;
              })
              .catch((error) => {
                console.error("Error:", error);
                const toast = document.querySelector("toast-alert");
                if (toast) {
                  toast.addMessage({
                    type: "error",
                    text: error,
                  });
                }
              });
          })
          .catch((error) => {
            console.error("Error:", error);
            const toast = document.querySelector("toast-alert");
            if (toast) {
              toast.addMessage({
                type: "error",
                text: error,
              });
            }
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        this.validateCustomizationFields();

        if (!submitButton || submitButton?.classList.contains("loading"))
          return;

        this.handleErrorMessage(this.errors);
        if (this.errors.length) return false;

        this.sidecart?.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("button--state-loading");

        const config = fetchConfig("json");

        const sections = this.sidecart
          ?.getSectionsToRender()
          .map((section) => section.section);

        const formData = new FormData(this.form);
        const id = parseInt(formData.get("id"));
        const quantity = parseInt(formData.get("quantity"));

        config.body = JSON.stringify({ id, quantity, sections: sections.filter(
          (item, index) => sections.indexOf(item) === index
        ),
        sections_url: window.location.pathname, });

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage([response.description]);
              return;
            }
            this.sidecart.renderContents(response);
          
            submitButton.classList.remove("button--state-loading");
            submitButton.classList.add("button--state-success");

            if (window.gift_available && !window.gift_variant_id.trim() == "") {
              this.addGiftToCart();
            }

            document
              .querySelector(".sidecart__contents")
              ?.classList.toggle("is-empty", response.item_count === 0);

            document.querySelector("body")?.classList.add("overflow-hidden");

            const cartUpdatedEvent = new CustomEvent("cartUpdated");
            document.dispatchEvent(cartUpdatedEvent);
          })
          .catch((e) => {
            console.error(e);
            const toast = document.querySelector("toast-alert");
            if (toast) {
              toast.addMessage({
                type: "error",
                text: error,
              });
            }
          })
          .finally(() => {
            submitButton.removeAttribute("aria-disabled");
            submitButton.removeAttribute("disabled");
            submitButton.classList.remove("button--state-loading");
            submitButton.classList.remove("button--state-success");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__errors");

        if (!this.errorMessageWrapper) return;

        if (!errorMessage || errorMessage?.length === 0) {
          this.errorMessageWrapper.textContent = "";
          this.errorMessageWrapper.setAttribute("hidden", true);
        } else {
          this.errorMessageWrapper.removeAttribute("hidden");
        }

        if (errorMessage?.length > 1) {
          let errorsList = "";
          errorMessage.forEach((error) => {
            errorsList += `<li>${error}</li>`;
          });
          this.errorMessageWrapper.innerHTML = `
        <strong>Please correct the following error(s):</strong>
        <ul class="product-form__errors-list">
          ${errorsList}
        </ul>
        `;
        } else {
          this.errorMessageWrapper.textContent = errorMessage[0];
        }
      }
    }
  );
}
